import { IdentityPerson } from '@reg/shared/model';

export class PersonSuggestion {
    public person: IdentityPerson;
    public hasFocus: boolean = false;

    public fillFromPerson(person: IdentityPerson): PersonSuggestion {
        this.person = person;
        return this;
    }

    public fillFromSearchHit(searchHit: Object): PersonSuggestion {
        const fields: any = searchHit['fields'];
        const expressions: any = searchHit['exprs'];

        this.person = new IdentityPerson();
        this.person.id = searchHit['id'].replace('person_', '');
        this.person.firstName = this.getSearchHitField('first_name', fields);
        this.person.lastName = this.getSearchHitField('last_name', fields);
        this.person.usaWrestlingNumber = parseInt(this.getSearchHitField('usa_wrestler_id', fields), null);
        this.person.highSchoolGradYear = parseInt(this.getSearchHitField('hs_grad_year', fields), null);
        this.person.location.name = this.getSearchHitField('location_name', fields);
        this.person.location.country = this.getSearchHitField('location_country', fields);
        this.person.location.city = this.getSearchHitField('location_city', fields);
        this.person.location.state = this.getSearchHitField('location_state', fields);
        this.person.location.zipCode = this.getSearchHitField('location_zip', fields);

        const age: number = parseInt(this.getSearchHitField('age', expressions), null);
        if (age > 0) {
            this.person.age = age;
        }

        return this;
    }

    private getSearchHitField(fieldName: string, fields: Object): string {
        if (fields[fieldName]) {
            if (Array.isArray(fields[fieldName])) {
                return fields[fieldName][0];
            }
            return fields[fieldName];
        }
        return null;
    }
}
